<div class="container-fluid">
    <div class="col-lg-2">
      <a routerLink="/addMaterial">
        <button type="button" class="btn btn-outline-dark">Add Material</button>
      </a>
    </div>
  
    <div class="row pt-3">
      <div class="col-sm-12">
        <div class="page-title-box">
          <div class="card">
            <div class="card-header bg-primary text-center text-white">
              Subcategories of {{ selectedCategory }}
            </div>
            <div class="card-body">
              <table class="table table-bordered">
                <thead>
                  <tr class="bg">
                    <th>Code</th>
                    <th>Description</th>
                    <th>Input</th>
                    <th>Output</th>
                    <th>Balance</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  <!-- Loop through each subcategory -->
                  <tr *ngFor="let subcategory of subcategories">
                    <!-- Display code prefix for each subcategory -->
                    <td>{{ codePrefix }}</td>
                    <!-- Display the current category and subcategory -->
                    <td>{{ selectedCategory }} -> {{ subcategory }}</td>
                    <!-- Display input, output, and balance -->
                    <td>{{ calculateTotalInput(subcategory) }}</td>
                    <td>{{ calculateTotalOutput(subcategory) }}</td>
                    <td>{{ calculateTotalBalance(subcategory) }}</td>
                    <td>
                      <!-- Action buttons -->
                      <button class="button-7" role="button" (click)="viewDetails(subcategory)">View Details</button>
                      <button class="button-7" role="button" (click)="onNextButtonClick(subcategory)">Next</button>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  